var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"pb-0",attrs:{"id":"inspire"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',{staticClass:"justify-center",attrs:{"wrap":""}},[_c('v-main',{attrs:{"alTag":"container"}},[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }